import angular from 'angular';
import MODULE_NAME from '../../app'
import DetailedList from './detailedListDirective'
import DynamicViewSelector from './dynamicViewSelectorDirective'
import NgAutofocus from './ngAutofocusDirective'
import NgTrim from './ngTrimDirective'
import SearchBar from './searchBarDirective'
import ngEndedHandler from './ngEndedHandler'

angular.module(MODULE_NAME)
.directive('detailedList', DetailedList)
.directive('dynamicViewSelector', DynamicViewSelector)
.directive('ngAutofocus', NgAutofocus)
.directive('ngTrim', NgTrim)
.directive('searchBar', SearchBar)
.directive('ngEndedHandler', ngEndedHandler)


// WEBPACK FOOTER //
// ./src/app/scripts/directives/index.js